import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { getBattleHistory } from "../../backend/history/history";
import { BattleHistory } from "../../types/history/history";
import { useMediaQuery } from "react-responsive";
import Arrow from "../../components/common/Arrow";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToRef, addScrollRef } from "../../backend/scrollToRef";

const HistoryCard = ({ history }: { history: BattleHistory }) => {
  const cutText = useMediaQuery({ query: `(max-width: 1200px)` });
  const isMedium = useMediaQuery({ query: `(max-width: 700px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 450px)` });

  return (
    <div style={styles.historyCardWrapper}>
      <div style={styles.historyCardContainer}>
        <div>
          <p
            style={{
              ...styles.dateText,
              fontSize: isSmall ? "2rem" : isMedium ? "2.5rem" : "3rem",
            }}
          >
            {history.date}
          </p>
          <p
            style={{
              ...styles.locationText,
              fontSize: isSmall ? "1rem" : isMedium ? "1.3rem" : "1.5rem",
            }}
          >
            {history.location}
          </p>
          <p
            style={{
              ...styles.descriptionText,
              fontSize: isSmall ? "1.5rem" : isMedium ? "1.75rem" : "2rem",
              width: cutText?"":"70%",
            }}
          >
            {history.description}
          </p>
        </div>
      </div>
    </div>
  );
};

const History = () => {
  const isMedium = useMediaQuery({ query: `(max-width: 700px)` });
  const isArrowUp = useMediaQuery({ query: `(max-width: 600px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 450px)` });
  const historyList = getBattleHistory();
  const [selectedHistoryIndex, setSelectedHistoryIndex] = useState(0);
  const sliderRef = useRef<Slider | null>(null);

  const settings = {
    infinite: false,
    dots: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (index: number) => setSelectedHistoryIndex(index),
    swipeToSlide: true,
    touchMove: true,
  };

  const historyRef = useRef(null);
  useEffect(() => {
    addScrollRef("history", historyRef);
  }, [historyRef]);

  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.state?.scrollTo === "history") {
      window.history.replaceState(null, "", window.location.href);
      scrollToRef(historyRef);
    }
  }, [location]);

  return (
    <div style={styles.historyWrapper} ref={historyRef}>
      <div style={{ ...styles.historyContainer, padding: isMedium ? "2rem 0rem" : "4rem 0rem" }}>
        <h2
          style={{
            ...styles.header,
            fontSize: isSmall ? "2.5rem" : isMedium ? "3.5rem" : "5rem",
          }}
        >
          Бойовий шлях полку
        </h2>
        <div>
          {isArrowUp && (
            <Arrow
              onClick={
                selectedHistoryIndex === 0 ? undefined : () => sliderRef.current?.slickPrev()
              }
              size="min(8rem,20vw)"
              style={{ ...styles.backArrow }}
              width="min(5rem,20vw)"
              height="min(5rem,20vw)"
              margin="2rem 0rem"
            />
          )}
        </div>
        <div style={{ marginLeft: "calc(0px - var(--main-container-margin))" }}>
          <Slider {...settings} ref={sliderRef}>
            {historyList.map((entry, index) => (
              <div key={index} style={{ ...styles.slide }}>
                <HistoryCard history={entry} />
              </div>
            ))}
          </Slider>
        </div>
        <div
          style={{
            ...styles.buttonRow,
            justifyContent: isArrowUp ? "flex-end" : "space-between",
          }}
        >
          {!isArrowUp && (
            <Arrow
              onClick={
                selectedHistoryIndex === 0 ? undefined : () => sliderRef.current?.slickPrev()
              }
              size="min(8rem,20vw)"
              style={styles.backArrow}
              width="min(5rem,20vw)"
              height="min(5rem,20vw)"
            />
          )}
          <Arrow
            onClick={
              selectedHistoryIndex === historyList.length - 1
                ? undefined
                : () => sliderRef.current?.slickNext()
            }
            style={styles.arrow}
            width="min(5rem,20vw)"
            height="min(5rem,20vw)"
            size="min(8rem,20vw)"
          />
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  historyWrapper: {
    display: "flex",
    width: "100vw",
    justifyContent: "center",
    backgroundColor: "var(--orange)",
  },
  historyContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "var(--main-container-width)",
    overflow: "visible",
  },
  header: {
    fontSize: "5rem",
    fontWeight: "bold",
    color: "var(--dark-grey)",
  },
  historyCardWrapper: {
    width: "100vw",
    display: "flex",
    justifyContent: "center",
  },
  historyCardContainer: {
    width: "var(--main-container-width)",
    display: "flex",
    flexDirection: "column",
  },
  dateText: {
    fontSize: "4rem",
    fontWeight: "300",
    color: "var(--grey)",
  },
  locationText: {
    fontSize: "1.5rem",
    color: "var(--grey)",
    marginBottom: "2rem",
  },
  descriptionText: {
    fontSize: "2.5rem",
    color: "var(--grey)",
  },
  buttonRow: {
    display: "flex",
    flexDirection: "row",
    marginTop: "2rem",
  },
  arrow: {
    height: "min(8rem,20vw)",
  },
  backArrow: {
    height: "min(8rem,20vw)",
    transform: "rotate(180deg)",
  },
  slide: {
    display: "flex",
    justifyContent: "center",
  },
};

export default History;
